import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

export default styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.error.main,
  color: theme.palette.getContrastText(theme.palette.error.main),
  '&:hover': {
    backgroundColor: theme.palette.error.dark,
  },
}));
